import React from "react";

const Footer = props => <tfoot class="table-footer">{props.children}</tfoot>;

export default Footer;
